export default __webpack_public_path__ + "static/media/my-health.b28471f0.svg";